import aiAssistant from './ai_assistant.svg';
import aiVoiceAnalysis from './ai_voice_analysis.svg';
import answer from './answer.svg';
import available from './available.svg';
import away from './away.svg';
import busy from './busy.svg';
import calendar from './calendar.svg';
import callMe from './call_me.svg';
import conference from './conference.svg';
import disconnect from './disconnect.svg';
import distributionList from './distribution_list.svg';
import extension from './extension.svg';
import forward from './forward.svg';
import goto from './goto.svg';
import group from './group.svg';
import http from './http.svg';
import hunt from './hunt.svg';
import isExternal from './is_external.svg';
import ivr from './ivr.svg';
import lcr from './lcr.svg';
import mapping from './mapping.svg';
import playback from './playback.svg';
import queue from './queue.svg';
import router from './router.svg';
import speech from './speech.svg';
import unreachable from './unreachable.svg';
import user from './user.svg';
import voicemail from './voicemail.svg';

export const nodeIcons = {
  ai_assistant: aiAssistant,
  ai_voice_analysis: aiVoiceAnalysis,
  answer,
  calendar,
  call_me: callMe,
  conference,
  custom_router: router,
  disconnect,
  distribution_list: distributionList,
  extension,
  forward,
  goto,
  group,
  http,
  hunt,
  is_external: isExternal,
  ivr,
  lcr,
  mapping,
  personal_voicemail: voicemail,
  playback,
  queue,
  router,
  speech,
  user,
  user_voicemail: voicemail,
  // Connection status icons, used by the presence and response router nodes.
  available,
  away,
  busy,
  unreachable,
} as const;

export type NodeIconName = keyof typeof nodeIcons;
